import React from 'react';
import { CATEGORY_PILLS, TYPE_PILLS } from './resourcesData';

const ResourcesFilterBar = ({ active, onChange, typeActive, onTypeChange }) => (
    <div className="lp-res-filterbar">
        <div className="lp-res-filterbar-inner" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                {CATEGORY_PILLS.map(pill => (
                    <button key={pill} className={`lp-res-pill ${active === pill ? 'is-active' : ''}`} onClick={() => onChange(pill)}>{pill}</button>
                ))}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                {TYPE_PILLS.map(pill => (
                    <button key={pill} className={`lp-res-pill ${typeActive === pill ? 'is-active' : ''}`} onClick={() => onTypeChange(pill)}>{pill}</button>
                ))}
            </div>
        </div>
    </div>
);

export default ResourcesFilterBar;
